'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@classify/react-core-components/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { translate } from '@openclassrooms/translations';
type VimeoPlayerProps = {
  id: number;
  onClose: () => void;
  isOpened: boolean;
  title: string;
};
function VimeoPlayer(t0) {
  const $ = _c(4);
  const {
    id,
    title
  } = t0;
  const videoRootRef = useRef(null);
  const t1 = `https://player.vimeo.com/video/${id}?autoplay=1`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      position: "absolute",
      border: "none",
      width: "100%",
      height: "100%",
      zIndex: 1
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1 || $[2] !== title) {
    t3 = <iframe title={title} ref={videoRootRef} src={t1} style={t2} />;
    $[1] = t1;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export default function VimeoPlayerOuter(t0) {
  const $ = _c(18);
  const {
    title,
    onClose,
    id,
    isOpened
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      style: {
        background: "none",
        boxShadow: "unset",
        margin: 0,
        padding: 0
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "none"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <Box sx={t2}><DialogTitle>{title}</DialogTitle></Box>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== id || $[5] !== title) {
    t4 = <VimeoPlayer id={id} title={title} />;
    $[4] = id;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  let t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = translate("global.word.close_video");
    t6 = {
      right: 0,
      position: "absolute",
      zIndex: 3,
      color: "background.default"
    };
    t7 = <CloseIcon />;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] !== onClose) {
    t8 = <IconButton onClick={onClose} aria-label={t5} sx={t6}>{t7}</IconButton>;
    $[10] = onClose;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== isOpened || $[13] !== onClose || $[14] !== t3 || $[15] !== t4 || $[16] !== t8) {
    t9 = <Dialog open={isOpened} onClose={onClose} fullScreen={true} PaperProps={t1}>{t3}{t4}{t8}</Dialog>;
    $[12] = isOpened;
    $[13] = onClose;
    $[14] = t3;
    $[15] = t4;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}